import Item from '~/shared/src/ci/Item';
import Reference from '~/shared/src/ci/Reference';
import moment from 'moment-timezone';

export const wrapDataXml = ( dataXml : string ) : string => {
    const momentNow = moment( Date.now() );

    let retVal = `<?xml version='1.0' encoding='UTF-8'?>\r\n`;

    retVal += `<Yoonite xmlns:xsi='http://www.w3.org/2001/XMLSchema-instance' xsi:noNamespaceSchemaLocation='https://fsz.de/yoonite-tech/xml/v2/Yoonite.xsd'>\r\n`;
    retVal += `<info>\r\n`.indent();
    retVal += `<version>2.0</version>\r\n`.indent( 2 );
    retVal += `<sender>Yoonite</sender>\r\n`.indent( 2 );
    retVal += `<timestamp>${momentNow.format( 'YYYY-MM-DD HH:mm:ss' )}</timestamp>\r\n`.indent( 2 );
    retVal += `</info>\r\n`.indent();
    retVal += dataXml;
    retVal += `</Yoonite>`;

    return retVal;
};

/**
 *
 * @param {string} dataXml
 * @param {Schema} schema
 */
export const getXmlForDataXml = ( dataXml : string, schema : Schema ) : string => {
    let data : string = '';

    data += `<data schema='${schema.toLowerCase()}'>\r\n`.indent();
    data += dataXml;
    data += `</data>\r\n`.indent();

    return wrapDataXml( data );
}

/**
 *
 * @param {string} dataContext
 * @param {number[]} [itemIdsToInclude]           If set the itemIds to be included in export
 * @param {number[]} [referenceIdsToInclude]      If set the referenceIds to be included in export
 * @param {boolean} [excludeDeleted]
 */
export const getXmlForContext = ( dataContext : string, itemIdsToInclude? : number[], referenceIdsToInclude? : number[], excludeDeleted : boolean = false, excludeOrphanedReferences : boolean = false ) : string => {
    let retVal : string = '';

    if ( global.data[ dataContext ] ) {
        retVal = getXmlForDataXml( getXmlPayloadForContext( dataContext, itemIdsToInclude, referenceIdsToInclude, excludeDeleted, excludeOrphanedReferences ), global.data[ dataContext ].schema );
    }

    return retVal;
}

/**
 *
 * @param {string} dataContext
 * @param {number[]} [itemIdsToInclude]           If set the itemIds to be included in export
 * @param {number[]} [referenceIdsToInclude]      If set the referenceIds to be included in export
 * @param {boolean} [excludeDeleted]
 * @param {boolean} [excludeOrphanedReferences]   If true only references pointing to included items will be included
 */
export const getXmlPayloadForContext = ( dataContext : string, itemIdsToInclude? : number[], referenceIdsToInclude? : number[], excludeDeleted : boolean = false, excludeOrphanedReferences : boolean = false ) : string => {
    let retVal : string = '';

    if ( global.data[ dataContext ] ) {
        const items : Item[]           = Object.values( global.data[ dataContext ].items ).filter( item => ( !itemIdsToInclude || itemIdsToInclude.includes( item.id ) )
                  && ( excludeDeleted ? !item.isDeleted() : true ) ),
              exportedItemIds          = items.map( item => item.id ),
              references : Reference[] = Object.values( global.data[ dataContext ].references ).filter( reference => ( !referenceIdsToInclude || referenceIdsToInclude.includes( reference.id ) )
                  && ( !excludeOrphanedReferences || ( exportedItemIds.includes( reference.srcItemId ) && exportedItemIds.includes( reference.destItemId ) ) )
                  && ( excludeDeleted ? !reference.isDeleted() : true ) );

        items.sort( ( item1, item2 ) => {
            const sortKey1 = `${item1.itemType.name}::${item1.key}`.toLowerCase();
            const sortKey2 = `${item2.itemType.name}::${item2.key}`.toLowerCase();

            return sortKey1 > sortKey2 ? 1 : sortKey1 < sortKey2 ? -1 : 0;
        } );

        for ( const item of items ) {
            retVal += item.toXML( undefined, 2 ) + '\r\n';
        }

        references.sort( ( reference1, reference2 ) => {
            const sortKey1 = `${reference1.srcItem?.itemType.name}::${reference1.srcItem?.key}::${reference1.referenceSet.referenceType.name}::${reference1.destItem?.itemType.name}::${reference1.destItem?.key}`.toLowerCase(),
                  sortKey2 = `${reference2.srcItem?.itemType.name}::${reference2.srcItem?.key}::${reference2.referenceSet.referenceType.name}::${reference2.destItem?.itemType.name}::${reference2.destItem?.key}`.toLowerCase();

            return sortKey1 > sortKey2 ? 1 : sortKey1 < sortKey2 ? -1 : 0;
        } );

        for ( const reference of references ) {
            retVal += reference.toXML( 2 ) + '\r\n';
        }
    }

    return retVal;
}
